module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "LeadScorz",
      "title": "LeadScorz"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "aler alert-danger"
  }, [_vm._v("An unexepected error happened, please try again later.")]) : (_vm.ok) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Thank you! Your email has been confirmed.")]) : _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Please click the \"Confirm email\" button to verify your email address.")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ok && !_vm.error),
      expression: "!ok && !error"
    }],
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Confirm Email")])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Go back to Sign In")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f971178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ConfirmEmail.vue
// module id = 636
// module chunks = 0